import script from "./CreatePassword.vue?vue&type=script&setup=true&lang=js"
export * from "./CreatePassword.vue?vue&type=script&setup=true&lang=js"

import "./CreatePassword.vue?vue&type=style&index=0&id=f8514b4c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f8514b4c"]])

export default __exports__